import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({
  title,
  checked,
  onChange,
  className = '',
  disabled = false,
  name,
  id
}) => {
  return (
    <label className={`flex items-center ${className}`}>
      <input
        type="checkbox"
        className="form-checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        name={name}
        id={id}
      />
      {title && <span className="ml-2 text-gray-700 text-xs">{title}</span>}
    </label>
  );
};

Checkbox.propTypes = {
  title: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.string
};

export { Checkbox }; 